export default __webpack_public_path__ + "static/media/grow.d52fcfd3.svg";